



















import { Vue, Prop, Component } from 'vue-property-decorator'
import AvgScore from './AvgScore.vue'

@Component({
  name: 'BarDashed',
  components: { AvgScore }
})
export default class extends Vue {
  @Prop({}) private legend!: any
  @Prop({}) private scoreConfig!: any
  @Prop({ default: '' }) private yName!: string
}
